import React, { useState, useEffect } from 'react'
import {  useSelector } from 'react-redux'

const { 
    REACT_APP_FIRSTS_PURCHASES_DISCOUNT_PERCENTAGE
     } = process.env

export const ShareLinkFloatingButton = (props) => {

    const [reset, setReset] = useState(true)

    const detailUser = useSelector(state => state.userDetail)
    const { user } = detailUser

    const toggleClassName = () => {
        setReset(false)
    };
    

    useEffect(() => {
        setTimeout(() => toggleClassName(), 6000);
    },[])

    const[ pixelsWidth, setPixelWidth ] = useState('0px')

    useEffect(() => {
        if (user) {
            const pixels = String(user.user_platform_balance).length * 0.9
            setPixelWidth(String(pixels) + 'em')
        }
    }, [user])

    return (
        <div>
            {user && (
                <a className={reset ? 'flip' : ''} href={`https://wa.me/?text=Hola! Estoy usando una plataforma que se llama Verdemi para comprar frutas y verduras. Te comparto mi código https://www.verdemi.com/%23/${user.personal_code}/ y disfruta de un descuento de ${REACT_APP_FIRSTS_PURCHASES_DISCOUNT_PERCENTAGE * 100}% en tus dos primeras compras y yo también recibiré descuentos`} target='_blank' rel="noreferrer" 
                    style={{ 
                        position: 'fixed',
                        width: user && user.user_platform_balance > 0 ?  `${pixelsWidth}`  : '2.8em',
                        height: '2.7em',
                        bottom: '0.5em',
                        right: '0.7em',
                        backgroundColor: '#00baff',
                        color: '#FFF',
                        borderRadius: '50px',
                        textAlign: 'center',
                        fontSize: '1.2em',
                        boxShadow: '2px 2px 3px #999',
                        zIndex: '100',
                        display: 'flex',
                        alignItems: 'center', // Centrado vertical
                        justifyContent: 'center', // Centrado horizontal
                    }}
                >
                    {user && user.user_platform_balance > 0 ? (
                        <p style={{margin: '0', verticalAlign: 'middle'}}>
                            ${new Intl.NumberFormat('co-CO').format(Number(user.user_platform_balance))}</p>
                    ) : (
                        <i className="fas fa-share-alt"></i>
                    )}
                </a>
            )}
        </div>
    )
}
